
export class TicketFilterModel {
  fromDate: Date;
  toDate: Date; 
}
